import { IssueDate } from '../../../helpers/issue/date';
import { DesignationDealStatus } from '../../../types/designation.types';
import { isDefined } from '../../../utils/utils';

export interface DesiDealStatusCellValue {
  dealStatus: DesignationDealStatus;
}

export function desiDealDateComparator(
  valA: IssueDate.DesiDealWithFormattedDate,
  valB: IssueDate.DesiDealWithFormattedDate
): number {
  if (!isDefined(valA) || !isDefined(valB)) {
    return 0;
  }
  // Check if the dates are the same
  if (valA.dealDate.isSame(valB.dealDate)) {
    // If dates are the same, compare using desiDealStatusComparator
    const statusComparison = desiDealStatusComparator(
      valA.dealStatus,
      valB.dealStatus
    );

    // If dealStatus is also the same, compare by Size (descending order)
    if (statusComparison === 0) {
      const sizeA = valA.size || 0;
      const sizeB = valB.size || 0;
      return sizeB - sizeA; // Descending order
    }

    return statusComparison;
  }

  // Otherwise, compare the dates
  return valA.dealDate.isAfter(valB.dealDate) ? 1 : -1;
}
export function desiDealStatusComparator(valA: string, valB: string): number {
  const statusOrder = ['Not Submitted', 'Partial', 'Submitted'];

  const indexA = statusOrder.indexOf(valA);
  const indexB = statusOrder.indexOf(valB);

  return indexA - indexB; // Sort based on the order in statusOrder
}
